import { render, staticRenderFns } from "./EntregarRopaExtra.vue?vue&type=template&id=7f9b3dd7&"
import script from "./EntregarRopaExtra.vue?vue&type=script&lang=js&"
export * from "./EntregarRopaExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports